export default class AddFolderController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        this.editMode = false;
        this.reset();
    }

    reset() {
        this.name = '';
        this.description = '';
    }

    enableEditMode() {
        this.editMode = true;
    }

    disableEditMode() {
        this.reset();
        this.editMode = false;
    }

    submit() {
        if (this.name) {
            const folder = {
                parent_id: this.parentId,
                name: this.name,
                description: this.description
            };
            this.onSubmit(
                this.eventEmitter({
                    folder
                })
            );
            this.disableEditMode();
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders/folder-tree/add-folder/add.controller.js